var _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSettings = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13 21h12v2H13zM11 13h12v2H11z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 5,
  x: 10.5,
  y: 19.5,
  fill: "currentColor",
  rx: 2.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 5,
  x: 20.5,
  y: 11.5,
  fill: "currentColor",
  rx: 2.5
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSettings);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzIDIxSDI1VjIzSDEzVjIxWiIgZmlsbD0iY3VycmVudENvbG9yIi8+CjxwYXRoIGQ9Ik0xMSAxM0gyM1YxNUgxMVYxM1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8cmVjdCB4PSIxMC41IiB5PSIxOS41IiB3aWR0aD0iNSIgaGVpZ2h0PSI1IiByeD0iMi41IiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHJlY3QgeD0iMjAuNSIgeT0iMTEuNSIgd2lkdGg9IjUiIGhlaWdodD0iNSIgcng9IjIuNSIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";